var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_Symbol.js
// module id = 552
// module chunks = 0 1 2 3 4 5 6 7 8